import { createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "list"
};
const _hoisted_2 = {
  class: "card"
};
const _hoisted_3 = {
  class: "list-wrap"
};
const _hoisted_4 = {
  class: "number"
};
const _hoisted_5 = {
  class: "card"
};
const _hoisted_6 = {
  class: "list-wrap"
};
const _hoisted_7 = {
  class: "number"
};
const _hoisted_8 = {
  class: "card"
};
const _hoisted_9 = {
  class: "list-wrap"
};
const _hoisted_10 = {
  class: "number"
};
const _hoisted_11 = {
  class: "card"
};
const _hoisted_12 = {
  class: "list-wrap"
};
const _hoisted_13 = {
  class: "number"
};
import { ref, watch } from 'vue';
import CardHeader from './CardHeader.vue';
export default {
  __name: 'BaseCount',
  props: {
    baseInfo: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props) {
    let props = __props;
    let dataInfo = ref({});
    watch(props.baseInfo, newValue => {
      dataInfo.value = newValue;
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(CardHeader, {
        title: "月活跃数量"
      }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_image, {
        class: "icon",
        fit: "fill",
        src: require('@/assets/images/screen/base-icon4.png')
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(dataInfo)?.monthlyActiveNumber), 1)])]), _createElementVNode("div", _hoisted_5, [_createVNode(CardHeader, {
        title: "总商品数量"
      }), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_image, {
        class: "icon",
        fit: "fill",
        src: require('@/assets/images/screen/food-icon1.png')
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(dataInfo)?.goodsNumber), 1)])]), _createElementVNode("div", _hoisted_8, [_createVNode(CardHeader, {
        title: "总菜谱数量"
      }), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_image, {
        class: "icon",
        fit: "fill",
        src: require('@/assets/images/screen/food-icon2.png')
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(dataInfo)?.recipeNumber), 1)])]), _createElementVNode("div", _hoisted_11, [_createVNode(CardHeader, {
        title: "总套餐数量"
      }), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_image, {
        class: "icon",
        fit: "fill",
        src: require('@/assets/images/screen/food-icon3.png')
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(dataInfo)?.setMealNumber), 1)])])]);
    };
  }
};